import { type RefObject, useEffect } from 'react';

import type { YouTubePlayer as BasePlayer } from 'react-youtube';

interface UsePauseVideo {
  isActive: boolean;
  playerRef: RefObject<BasePlayer>;
}

const usePauseVideo = (props: UsePauseVideo) => {
  const { isActive, playerRef } = props;

  useEffect(() => {
    if (!isActive) {
      playerRef.current?.getInternalPlayer().pauseVideo();
    }
  }, [isActive, playerRef]);
};

export default usePauseVideo;
